import { EventMessage, Logger, PublicClientApplication, EventType } from '@azure/msal-browser'
import { GetMsalConfiguration } from './MsalConfig'
import { MsalLogger } from './MsalLogger'
import { Logger as AppInsightLogger } from '../appinsights/Logger'
import { removeSessionStorage, setSessionStorage } from '../../shared/utilities/Session'
import { BrowserSessionKey, MsalCurrentStateSessionKey } from '../../shared/Constants'

export class MsalInstance {
  private static instance: PublicClientApplication
  constructor() {
    if (MsalInstance.instance) {
      throw new Error('Error - use MsalInstance.getInstance()')
    }
  }

  static getInstance(isSimulation?: boolean): PublicClientApplication {
    if (!MsalInstance.instance) {
      AppInsightLogger.LogInfo({ message: 'New MSAL Instance Created' })
      const msalInstance = new PublicClientApplication(GetMsalConfiguration(isSimulation ?? false))
      msalInstance.setLogger(
        new Logger({
          piiLoggingEnabled: false,
          loggerCallback: MsalLogger
        })
      )

      //Setting active account
      msalInstance.addEventCallback((message: EventMessage) => {
        // v5: LOGIN_START was consolidated into ACQUIRE_TOKEN_START
        if (message.eventType === EventType.ACQUIRE_TOKEN_START) {
          setSessionStorage(MsalCurrentStateSessionKey, EventType.ACQUIRE_TOKEN_START)
          AppInsightLogger.LogInfo({ message: 'Login Started' })
        }

        if (message.eventType === EventType.LOGIN_SUCCESS) {
          setSessionStorage(MsalCurrentStateSessionKey, EventType.LOGIN_SUCCESS)
          const accounts = msalInstance.getAllAccounts()
          if (accounts.length > 0) {
            AppInsightLogger.LogInfo({ message: `Setting active account ${accounts[0].username}` })
            msalInstance.setActiveAccount(accounts[0])
          }
        }

        if (message.eventType === EventType.LOGOUT_START) {
          setSessionStorage(MsalCurrentStateSessionKey, EventType.LOGOUT_START)
          AppInsightLogger.LogInfo({ message: 'Logout started' })
        }

        if (message.eventType === EventType.LOGOUT_SUCCESS) {
          setSessionStorage(MsalCurrentStateSessionKey, EventType.LOGOUT_SUCCESS)
          AppInsightLogger.LogInfo({ message: 'Logout end clearning browser session key' })
          removeSessionStorage(BrowserSessionKey)
        }

        // v5: LOGIN_FAILURE was consolidated into ACQUIRE_TOKEN_FAILURE
        if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
          setSessionStorage(MsalCurrentStateSessionKey, EventType.ACQUIRE_TOKEN_FAILURE)
          AppInsightLogger.LogInfo({ message: `Login failed isSimulation: ${isSimulation}` })
          AppInsightLogger.LogInfo({ message: 'Acquire token failed.' })
        }
      })

      MsalInstance.instance = msalInstance
    }
    return MsalInstance.instance
  }
}
